import { render } from "./TelefonGirisi.vue?vue&type=template&id=2f9db7ce"
import script from "./TelefonGirisi.vue?vue&type=script&lang=js"
export * from "./TelefonGirisi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__